import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { isAuthenticated } from '../utils/auth';

export const PrivateRoute: FC = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" replace />;
};
